import React from 'react';
import {default as MUIModal, ModalProps} from '@mui/joy/Modal';

export const Modal = (props: ModalProps) => {
    return (
        <MUIModal
            disableAutoFocus={true}
            disableEnforceFocus={true}
            disableRestoreFocus={true}
            keepMounted
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 4000,
            }}
            {...props}
        />
    )
}